export const SAN_V1ResourcesEN: SAN_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errorMissingInput: "Please fill in all fields",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    signatureTitle: "Signature",
    datum: {
      label: "Date",
      placeholder: "Please enter date",
      name: "datum",
    },
    dokument: {
      label: "Document",
      placeholder: "Please enter document",
      name: "dokument",
      description: () => (
        <>
          <h4>Drop files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
    },
    vaziOd: {
      label: "Valid from",
      name: "vaziOd",
    },
    vaziDo: {
      label: "Valid until",
      name: "vaziDo",
    },
    uposlenik: {
      label: "Employee",
      name: "uposlenik",
      placeholder: "Please enter employee name",
    },
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
};

interface InputField {
  label: string;
  name: string;
  placeholder?: string;
  description?: () => JSX.Element;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  dokument: InputField;
  vaziOd: InputField;
  vaziDo: InputField;
  uposlenik: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface SAN_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
